<div class="map-toolbar" [class.map-toolbar--collapsed]="toolbarCollapsed">
    <div class="map-toolbar__content">
        <ng-container *ngIf="!toolbarCollapsed; else compactToolbar">
            <div class="toolbar-row">
                <div class="bubble date-bubble">
                    <span class="topic-label">{{ 'bcmBerthsMap.actionBar.viewTopic' | translate }}</span>
                    <div class="view-mode-toggle" role="group" [attr.aria-label]="'bcmBerthsMap.actionBar.viewModeLabel' | translate">
                        <button type="button"
                                class="view-mode-option"
                                [class.active]="(viewMode$ | async) === 'now'"
                                [attr.aria-pressed]="(viewMode$ | async) === 'now'"
                                (click)="showNow()"
                                [matTooltip]="'bcmBerthsMap.actionBar.nowTooltip' | translate">
                            {{ 'bcmBerthsMap.actionBar.now' | translate }}
                        </button>
                        <button type="button"
                                class="view-mode-option"
                                [class.active]="(viewMode$ | async) === 'range'"
                                [attr.aria-pressed]="(viewMode$ | async) === 'range'"
                                (click)="showRange()"
                                [matTooltip]="'bcmBerthsMap.actionBar.rangeTooltip' | translate">
                            {{ 'bcmBerthsMap.actionBar.range' | translate }}
                        </button>
                    </div>

                    <ng-container *ngIf="(viewMode$ | async) === 'now'">
                        <span class="now-stamp">
                            {{ 'bcmBerthsMap.actionBar.standAt' | translate:{ time: (snapshotTime$ | async | date:'HH:mm') } }}
                        </span>
                        <button mat-stroked-button
                                type="button"
                                class="follow-chip"
                                [class.active]="liveMode$ | async"
                                (click)="toggleLiveMode()"
                                [matTooltip]="'bcmBerthsMap.actionBar.followClockTooltip' | translate">
                            {{ 'bcmBerthsMap.actionBar.followClock' | translate }}
                        </button>
                    </ng-container>

                    <ng-container *ngIf="(viewMode$ | async) === 'range'">
                        <div class="range-block">
                            <div class="date-range-fields" [formGroup]="dateForm">
                                <button mat-icon-button
                                        type="button"
                                        class="panel-button"
                                        (click)="berthsFilterService.jumpDays(-1)"
                                        [matTooltip]="'bcmBerthsMap.actionBar.previousDayTooltip' | translate">
                                    <mat-icon>keyboard_arrow_left</mat-icon>
                                </button>

                                <app-date-time-picker
                                        class="date-input"
                                        [formGroup]="dateForm"
                                        formControlName="start"
                                        [time]="true">
                                </app-date-time-picker>

                                <span class="date-separator">–</span>

                                <app-date-time-picker
                                        class="date-input"
                                        [formGroup]="dateForm"
                                        formControlName="end"
                                        calendarAlign="end"
                                        [time]="true">
                                </app-date-time-picker>

                                <button mat-icon-button
                                        type="button"
                                        class="panel-button"
                                        (click)="berthsFilterService.jumpDays(1)"
                                        [matTooltip]="'bcmBerthsMap.actionBar.nextDayTooltip' | translate">
                                    <mat-icon>keyboard_arrow_right</mat-icon>
                                </button>
                            </div>

                            <div class="situation-presets" role="group" [attr.aria-label]="'bcmBerthsMap.actionBar.situationLabel' | translate">
                                <button type="button"
                                        class="situation-chip"
                                        [class.active]="(situation$ | async) === 'today'"
                                        (click)="applySituation('today')"
                                        [matTooltip]="'bcmBerthsMap.actionBar.situationTodayTooltip' | translate">
                                    {{ 'bcmBerthsMap.actionBar.today' | translate }}
                                </button>
                                <button type="button"
                                        class="situation-chip"
                                        [class.active]="(situation$ | async) === 'tonight'"
                                        (click)="applySituation('tonight')"
                                        [matTooltip]="'bcmBerthsMap.actionBar.situationTonightTooltip' | translate">
                                    {{ 'bcmBerthsMap.actionBar.tonight' | translate }}
                                </button>
                                <button type="button"
                                        class="situation-chip"
                                        [class.active]="(situation$ | async) === 'tomorrow'"
                                        (click)="applySituation('tomorrow')"
                                        [matTooltip]="'bcmBerthsMap.actionBar.situationTomorrowTooltip' | translate">
                                    {{ 'bcmBerthsMap.actionBar.tomorrow' | translate }}
                                </button>
                                <span class="chip-divider"></span>
                                <button type="button"
                                        class="situation-chip"
                                        [class.active]="stayLengthActive(1)"
                                        (click)="applyStayLength(1)">
                                    {{ 'bcmBerthsMap.actionBar.oneNight' | translate }}
                                </button>
                                <button type="button"
                                        class="situation-chip"
                                        [class.active]="stayLengthActive(3)"
                                        (click)="applyStayLength(3)">
                                    {{ 'bcmBerthsMap.actionBar.threeDays' | translate }}
                                </button>
                                <button type="button"
                                        class="situation-chip"
                                        [class.active]="stayLengthActive(7)"
                                        (click)="applyStayLength(7)">
                                    {{ 'bcmBerthsMap.actionBar.oneWeek' | translate }}
                                </button>
                            </div>
                        </div>
                    </ng-container>

                    <span class="chip-divider"></span>
                    <button mat-icon-button
                            type="button"
                            class="panel-button"
                            (click)="berthsFilterService.updateBerthView()"
                            [matTooltip]="'bcmBerthsMap.actionBar.fabReload' | translate">
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>

                <div class="bubble search-panel" *ngIf="(viewMode$ | async) === 'range'">
                    <span class="topic-label">{{ 'bcmBerthsMap.actionBar.searchTopic' | translate }}</span>
                    <advanced-filters></advanced-filters>
                </div>
            </div>
        </ng-container>

        <ng-template #compactToolbar>
            <p class="map-toolbar__summary">{{ compactSummary$ | async }}</p>
        </ng-template>
    </div>

    <div class="map-toolbar__actions">
        <button mat-stroked-button
                type="button"
                class="map-toolbar__toggle"
                (click)="toggleToolbarCollapsed()"
                [attr.aria-expanded]="!toolbarCollapsed"
                [matTooltip]="(toolbarCollapsed ? 'bcmBerthsMap.actionBar.expandToolbarTooltip' : 'bcmBerthsMap.actionBar.collapseToolbarTooltip') | translate">
            <mat-icon>{{ toolbarCollapsed ? 'unfold_more' : 'unfold_less' }}</mat-icon>
            <span class="map-toolbar__toggle-label">
                {{ (toolbarCollapsed ? 'bcmBerthsMap.actionBar.expandToolbar' : 'bcmBerthsMap.actionBar.collapseToolbar') | translate }}
            </span>
        </button>
    </div>
</div>
